import { Injectable } from '@angular/core';
import { TranslationService } from '@prekog/common-ui';
import { EmailTemplate } from './model/email-template.model';

@Injectable({
    providedIn: 'root'
})
export class EmailService {
    private readonly EMAIL: string = 'email.';

    private readonly STRING: string = 'string';

    constructor(private _translateService: TranslationService) { }

    getTranslatedName(emailTemplate: EmailTemplate): string {
        let translatedValue = emailTemplate.templateName;
        if (!emailTemplate.newsletter) {
            const key = this.EMAIL + emailTemplate.templateName;
            translatedValue = this._translateService.translate(key);
        }

        if (typeof translatedValue === this.STRING) {
            return translatedValue!;
        }

        return translatedValue!;
    }
}
